export default (
  checksLength: number | undefined,
  repetitions: number | undefined,
) => (checksLength && repetitions && Math.trunc(checksLength / repetitions) + 1) || 1;
